/**
 * Доменные типы и перечисления (без геймплея).
 */

// ---------------------------------------------------------------------------
// Сохранения
// ---------------------------------------------------------------------------

export interface GameSave {
  version?: number;
}

// ---------------------------------------------------------------------------
// Сложность (число деталей пазла)
// ---------------------------------------------------------------------------

/** Допустимые размеры пазла по количеству деталей. 16 — только для туториала. */
export type Difficulty = 16 | 24 | 45 | 84 | 144 | 252 | 448 | 1200;

/** Все поддерживаемые сложности (в деталях). */
export const PUZZLE_DIFFICULTIES = [16, 24, 45, 84, 144, 252, 448, 1200] as const;

/** Сложности для выбора в модалке пазлов подборки. */
export const PACK_PUZZLE_DIFFICULTIES = [45, 84, 144, 252, 448] as const;

// ---------------------------------------------------------------------------
// Источник пазла
// ---------------------------------------------------------------------------

/** daily — ежедневный пазл, pack — из набора. */
export type PuzzleSource = 'daily' | 'pack';

// ---------------------------------------------------------------------------
// Идентификаторы
// ---------------------------------------------------------------------------

export type PuzzleId = string;
export type PackId = string;

/** Ключ ежедневного пазла: строка даты YYYY-MM-DD. */
export type DailyKey = string;

// ---------------------------------------------------------------------------
// Метаданные пазла и набора
// ---------------------------------------------------------------------------

/** Метаданные одного пазла. Daily всегда 45 деталей (см. Difficulty). */
export interface PuzzleMeta {
  id: PuzzleId;
  source: PuzzleSource;
  /** Путь к изображению (например в assets). */
  imagePath?: string;
  /** Ключ картинки для коллекции (из content.json). */
  imageKey?: string;
  /** Для source === 'pack'. */
  packId?: PackId;
  title?: string;
  /** Порядок внутри набора. */
  orderInPack?: number;
  /** Базовые монеты за сборку. */
  rewardCoinsBase?: number;
}

/** Метаданные набора пазлов (pack). */
export interface PackMeta {
  id: PackId;
  title: string;
  puzzleIds: PuzzleId[];
}
